// @ts-strict-ignore
import styled from "styled-components";
import NextImage from "../NextImage";

export const SocialsIcon = styled(NextImage).attrs({
  height: 32,
  width: 32
})`
  margin: 0 8px;
  transition: 0.2s ease-in;
  border: white;
  border-radius: 24px;
  &:hover {
    filter: invert();
  }
`;
